<template>
    <div class="row">
        <div
            v-for="(item, idx) in items"
            :key="idx"
            class="col-3 d-flex"
        >
            <NuxtLink
                :to="localePath({name: 'blog-code', params: {code: item.code}})"
                class="card-link bg-transparent border-0 flex-fill d-flex flex-column my-0"
                @click.prevent="$emit('click', item)"
            >
                <h5 class="title mb-3">{{ item.name }}</h5>
                <p class="blog-item-description flex-grow-1">{{ item.description }}</p>
                <div
                    class="mt-auto pt-3"
                >
                    {{ $t('blog.read_more') }} <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="currentColor" style="transform: rotate(-90deg);">
                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </div>
            </NuxtLink>
        </div>
    </div>
</template>

<script setup>
import { useLocalePath } from '#imports';

const localePath = useLocalePath();

defineProps({
    items: {
        type: Array,
        required: true,
    }
})
defineEmits(['click'])
</script>

<style scoped>
.card-link {
    cursor: pointer;
}

h5.title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2em;
    max-height: 2.4em;
}

p.blog-item-description {
    position: relative;
    line-height: 1.2em;
    max-height: calc(1.2em * 3);
    margin: 0;
    overflow: hidden;
}

p.blog-item-description::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: calc(1.2em * 2);
    pointer-events: none;
}

.bg-transparent {
    display: flex;
    flex-direction: column;
}

a {
    margin-top: auto;
}
</style>
